module.exports = "pegasus_template/assets/gray-large-facebook.png";